import { Button, Popconfirm, Tooltip } from 'antd';
import { useNavigate } from "react-router-dom";
import { EyeFilled, EditFilled } from '@ant-design/icons';
import dayjs from 'dayjs'

const Columns = (hasPermission, showModal, filters, isSuperuser) => {
  console.log("filters", filters)
  const navigate = useNavigate();
  return [
     {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => (a.name || '').localeCompare(b.name || ''),
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '20%',
    },
    {
      title: "Estado",
      dataIndex: "status",
      key: "status",
      render: (status) => status?.name || "N/A",
      sorter: (a, b) => a.status?.name?.localeCompare(b.status?.name),
      filters: filters.statuses.map(status => ({
        text: status.name,
        value: status.name
      })),
      defaultFilteredValue: filters.dashboardStatusFilter ? [filters.dashboardStatusFilter] : undefined,      
      onFilter: (value, record) => record.status?.name === value,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#E0F8AD',
          color: '#006939',
          fontWeight: 'bold',
        },
      }),
      showSorterTooltip: false,
      width: '20%',
    },
    {
      title: "Responsable Área",
      dataIndex: "responsible_area",
      key: "responsible_area",
      render: (area) => area?.name || "N/A",
      sorter: (a, b) =>
        a.responsible_area?.name?.localeCompare(b.responsible_area?.name),
      filters: filters.responsibleAreas.map(area => ({
        text: area.name,
        value: area.name,
      })),
      defaultFilteredValue: filters.dashboardAreasFilter || undefined,
      onFilter: (value, record) => record.responsible_area?.name === value,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#E0F8AD',
          color: '#006939',
          fontWeight: 'bold',
        },
      }),
      showSorterTooltip: false,
      width: '30%',
    },
    {
      title: "Condición",
      dataIndex: "condition",
      key: "condition",
      render: (condition) => condition || "N/A",
      sorter: (a, b) =>
        a.condition?.localeCompare(b.condition || '') || 0,
      filters: filters.conditions.map(condition => ({
        text: condition.name,
        value: condition.name,
      })),
      defaultFilteredValue: filters.dashboardConditionFilter ? [filters.dashboardConditionFilter] : undefined, 
      onFilter: (value, record) => record.condition === value,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#E0F8AD',
          color: '#006939',
          fontWeight: 'bold',
        },
      }),
      showSorterTooltip: false,
      width: '25%',
    },
    {
      title: "Fecha Comprometida",
      dataIndex: "date_committed",
      key: "date_committed",
      sorter: (a, b) => {
        const dateA = a.date_committed ? new Date(a.date_committed).getTime() : 0;
        const dateB = b.date_committed ? new Date(b.date_committed).getTime() : 0;
        return dateA - dateB;
      },
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '35%',
      render: (date_committed) =>
        date_committed
          ? dayjs(date_committed).format('DD/MM/YYYY')
          : 'No especificada'
    },
    {
      title: 'Activo',
      dataIndex: ['gap', 'dependency_control', 'dependency', 'asset', 'name'],
      key: 'asset',
      sorter: (a, b) =>
        a.gap?.dependency_control?.dependency?.asset?.name
          ?.localeCompare(b.gap?.dependency_control?.dependency?.asset?.name),
      filterSearch: true,
      filters: filters.assets.map(asset => ({
        text: asset.name,
        value: asset.name
      })),
      defaultFilteredValue: filters.dashboardAssetsFilter,
      onFilter: (value, record) =>
        record.gap?.dependency_control?.dependency?.asset?.name === value,
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      width: '25%'
    },
    {
      title: 'Dependencia',
      dataIndex: ['gap', 'dependency_control', 'dependency', 'name'],
      key: 'dependency',
      sorter: (a, b) =>
        a.gap?.dependency_control?.dependency?.name
          ?.localeCompare(b.gap?.dependency_control?.dependency?.name),
      filterSearch: true,
      filters: filters.dependencies.map(dep => ({
        text: dep.name,
        value: dep.name
      })),
      onFilter: (value, record) =>
        record.gap?.dependency_control?.dependency?.name === value,
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      width: '30%'
    },
    {
      title: 'Control',
      dataIndex: ['gap', 'dependency_control', 'control', 'title'],
      key: 'control',
      sorter: (a, b) =>
        a.gap?.dependency_control?.control?.title
          ?.localeCompare(b.gap?.dependency_control?.control?.title),
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      ellipsis: true,
      render: (_, record) => {
        const title = record.gap?.dependency_control?.control?.title;
        if (!title) return <span style={{ color: '#999' }}>Sin título</span>;

        const truncated = title.length > 50 ? `${title.substring(0, 50)}...` : title;

        return title.length > 40 ? (
          <Tooltip title={title}>
            <span>{truncated}</span>
          </Tooltip>
        ) : (
          <span>{truncated}</span>
        );
      },
      width: '30%'
    },  
    {
      title: 'Tipo GAP',
      dataIndex: ['gap', 'type'],
      key: 'type',
      sorter: (a, b) => a.gap?.type?.localeCompare(b.gap?.type),
      filters: filters.types.map(type => ({
        text: type.name,
        value: type.name
      })),
      filteredValue: filters.filteredTypeValue,
      onFilter: (value, record) => {
        // Si es filtro combinado desde dashboard
        if (filters.isCombinedFilter) {
          return record.gap?.status === filters.dashboardStatusFilter && 
                record.gap?.type === filters.dashboardTypeFilter;
        }
        // Filtro normal
        return record.gap?.type === value;
      },
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      width: '20%'
    },
    {
      title: "Responsable GAP",
      dataIndex: ['gap', 'area', 'name'],
      key: "area",
      sorter: (a, b) =>
        a.gap?.area?.name?.localeCompare(b.gap?.area?.name),
      filters: filters.areas.map(area => ({
        text: area.name,
        value: area.name
      })),
      onFilter: (value, record) => record.gap?.area?.name === value,
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' }
      }),
      showSorterTooltip: false,
      width: '30%',
    },
    {
      title: "Issue Asociado",
      dataIndex: "issue",
      key: "issue",
      render: (issue) => issue?.type || "N/A",
      sorter: (a, b) => a.issue?.type?.localeCompare(b.issue?.type),
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#E0F8AD',
          color: '#006939',
          fontWeight: 'bold',
        },
      }),
      showSorterTooltip: false,
      width: '30%',
    },
    {
      title: "Acciones",
      key: "actions",
      render: (_, record) => {
        const canUpdateGap = isSuperuser || hasPermission("gaps", "update", record.gap?.area?.id);
        const canUpdateTasks = isSuperuser || hasPermission("tasks", "update", record.responsible_area?.id);
        const canEdit = canUpdateGap || canUpdateTasks;

        // Verificar si la tarea está finalizada
        const isTaskFinished = record.status?.index === 3;
        // El botón se deshabilita si NO tiene permisos O si está finalizada
        const isEditDisabled = !canEdit || isTaskFinished;
        
        return (
          <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
            <Button 
              type="link" 
              style={{ color: '#006939', fontSize: 18,  padding: '0px 4px' }} 
              onClick={() => navigate(`/tasks/${record.code}`)}
            >
              <Tooltip title="Ver Tarea"><EyeFilled /></Tooltip>
            </Button>
            <Button
              disabled={isEditDisabled}
              style={{ color: !isEditDisabled ? '#006939' : '#999999', fontSize: 18, padding: '0px 2px' }}
              type="link" 
              onClick={() => showModal(record)}>
              <Tooltip title="Editar Tarea"><EditFilled /></Tooltip>
            </Button>
          </div>
        )
      },
      onHeaderCell: () => ({ 
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold', textAlign: 'center' } 
      }),
      align: 'center', 
      width: '20%',
    }  
  ];
};

export default Columns;